import {getCurrentYear} from '../../utils/commons'
import KitchenTopPicksLogo from './logo'
import {kitchenTopPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'kitchentoppicks' as const,
  domainType: 'picks' as const,
  siteName: 'Kitchen Top Picks',
  logo: <KitchenTopPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/kitchentoppicks.png',
  styles: kitchenTopPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-MKBST5CNR4',
    camelCaseUrl: 'KitchenTopPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | KitchenTopPicks.com – Expert Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the best kitchen products with KitchenTopPicks.com. Our expert team provides curated lists, detailed product reviews, and key feature insights to help you choose`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
